import type { FaireProductEntity } from "../../entity_types/product";

export const p_vm7ajj96d5: FaireProductEntity = {
  token: "p_vm7ajj96d5",
  type: "product",
  name: "Candied Pecans, 4.0 oz.",
  brandToken: "b_f0wtyxk4dn",
  brandName: "Chesebro's Handmade Confections and Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/c64e9c5a4bd2d5d7484400b0c535d32330b920b8042cf340760c5ef9eb4f6182.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e0082728ca41d0f37caec4bd1677d84d34bb0ff6963fe59c23e8b56dbb526710.jpeg",
  ],
  priceDollars: 5.54,
  description:
    "We slow roast each batch of our mammoth pecan halves with just the right amount of sugar, cinnamon and vanilla to make the perfect snackable treat! Each 4 ounce bag is carefully packaged by hand to ensure the best possible quality.\n\nThese delectable nuts have so many great uses:\n\nEat them right our of the bag!\nAdd them to a salad as a gourmet topping with just the right amount of crunch!\nFeeling adventurous? Mix them with other yummies in a homemade trail mix!\nYams and sweet potatoes - sprinkle them on top of baked, mashed or a casserole!\nOur candy is cooked in a copper kettle with top quality ingredients before being formed by vintage equipment. We're proud to say our candies are family made in the USA!\n\nManufactured in a facility that processes tree nuts, peanuts, dairy and soy products. Do not eat if you have allergies to these products.",
  tags: [],
  msrpDollars: 11.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:28.820Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
